<template>
  <div class="detail-wrap">
    <el-form ref="tenant" :rules="rules" :model="tenant" :inline-message="true" class="demo-ruleForm">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}购买店铺
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData"
                     v-if="(buy_shop_add && formData.id == null) || (buy_shop_edit && formData.id != null)">保存
          </el-button>
        </div>
      </div>
      <div>

        <!-- 工单来源 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  编码
                </th>
                <td>
                  <el-input type="text" autocomplete="off"
                            @blur="inspection"
                            v-model="formData.shopCode" clearable/>
                </td>

                <th>
                  <em class="f-red">*</em>
                  名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.shopName" clearable/>
                </td>

                <th>
                  <em class="f-red">*</em>
                  别名
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.otherShopName" clearable/>
                </td>

                <th>
                  <em class="f-red">*</em>
                  类型</th>
                <td>
                  <el-select v-model="formData.shopType">
                    <el-option :value="1" label="线上店铺"></el-option>
                    <el-option :value="2" label="线下店铺"></el-option>
                  </el-select>
                </td>

                <th>
                  <em class="f-red">*</em>
                  状态</th>
                <td>
                  <el-select v-model="formData.stat">
                    <el-option :value="1" label="可用"></el-option>
                    <el-option :value="2" label="不可用"></el-option>
                  </el-select>
                </td>
              </tr>
              <tr>
                <th>
<!--                  <em class="f-red">*</em>-->
                  创建人
                </th>
                <td>{{ formData.createBy }}</td>
                <th>
<!--                  <em class="f-red">*</em>-->
                  创建时间
                </th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="d-item">
            <div class="title first">
              <b>补充信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  店铺说明
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.shopDesc" clearable/>
                </td>

                <th>
                  店长
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.shopManager" clearable/>
                </td>

                <th>
                  联系方式
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.shopPhone" clearable/>
                </td>
                <th>
                  指定服务商
                </th>
                <td>
                  <site-pop-search :site-id.sync="formData.siteId"
                                   :site-name.sync="formData.siteName"
                                   :org-name.sync="formData.orgName"
                                   :org-id-path.sync="formData.orgIdPath"
                                   :org-id.sync="formData.orgId"
                  />
<!--                  <el-input style="width: 165px;" type="text" autocomplete="off"-->
<!--                            :clearable="true"-->
<!--                            v-model="formData.siteName"-->
<!--                            :readonly="true">-->
<!--                    <i slot="suffix" style="margin-top: 0" class="el-input__icon el-icon-search"-->
<!--                       @click="showPreconditionDialog = true"></i>-->
<!--                  </el-input>-->
                </td>
              </tr>
              <tr>

                <th>省/市/区/镇</th>
                <td colspan="3">
                  <el-cascader :props="areaProps" v-model="areaValues" :clearable="true"
                               @change="handleChange" ref="cascaderAddr"
                               style="width: 100%"
                               :options="areaOption">
                  </el-cascader>
                </td>

                <th>
                  详细地址
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.address" clearable/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div>
          </div>
        </div>
      </div>
    </el-form>
    <preconditionDialog v-if="showPreconditionDialog" @commit="commitSelectedRow" :visiable.sync="showPreconditionDialog"
                        multi="true" />
  </div>
</template>
<script>
import request from "@/router/axios";
import {mapGetters} from "vuex";
import {editPageMixins} from "@/mixins/tabChang";
import api from "@/api/projectApi";
import ar from "element-ui/src/locale/lang/ar";
import preconditionDialog from '@/views/dialogCommon/radioSiteDialog.vue';
import sitePopSearch from "@/components/formItem/sitePopSearch.vue";


export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    initTableList: {
      type: Function,
      default: null
    }
  },
  components: {sitePopSearch, preconditionDialog},
  data() {
    return {
      buy_shop_add: false,
      buy_shop_edit: false,
      showPreconditionDialog: false,
      formData: {
        id: null,
        shopType: null,  // 类型:1线上店铺;2线下店铺
        shopCode: null,  // 编码;自定填入,同厂商下惟一即可
        shopName: null,  // 名称
        otherShopName: null,
        stat: 1,  // 状态:1可用;2不可用
        shopDesc: null,  // 店铺说明
        shopManager: null,  // 店长
        shopPhone: null,  // 联系方式
        province: null,  // 省
        city: null,  // 市
        county: null,  // 区
        town: null,  // 镇
        address: null,  // 详细地址
      },
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      areaOption: [],
      areaValues: null,



      tenant: {
        id: null,
        orderTypeName: null,
        isShowwx: 0,
        isShowIssue: 1,
        isShowSiteIssue: 0,
        code: null,
        seq: 0
      },
      rules: {
        orderTypeName: [{required: true, prop: '来源名称', type: 'string', maxlength: 20}],
        code: [{required: false, prop: '编码', type: 'string', maxlength: 10}]
      },

      activeName: 'first',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    this.buy_shop_add = this.permissions['buy_shop_add']
    this.buy_shop_edit = this.permissions['buy_shop_edit']
  },
  mounted() {
    this.getData();
    console.log(this.tenant, "tenant的值");
    console.log(this._dataId, "_dataId的值");
  },
  methods: {
    inspection() {
      if (this.formData.shopCode) {
        this.$http.post(api.basBuyShop.inspectionUrl, {
          value: this.formData.shopCode,
          id: this.formData.id,
        }).then(res => {
          if (!res.data.data) {
            this.$message.error("编码已存在，请重新输入")
            this.formData.shopCode = null
          }
        })
      }
    },

    commitSelectedRow(data) {
      this.formData.siteId = data.id;
      this.formData.siteName = data.name;
    },


    // 地址三级联动
    handleChange() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        this.formData.areaId = areaNode.value;
        if (areaNode[0].level == 1) {
          this.formData.province = null;
          this.formData.city = null;
          this.formData.county = null;
          this.formData.town = null;
        } else if (areaNode[0].level == 2) {
          this.formData.province = areaNode[0].label;
          this.formData.city = null;
          this.formData.county = null;
          this.formData.town = null;
        } else if (areaNode[0].level == 3) {
          this.formData.city = areaNode[0].label;
          this.formData.county = null;
          this.formData.town = null;
        } else if (areaNode[0].level == 4) {
          this.formData.county = areaNode[0].label;
          this.formData.town = null;
        } else if (areaNode[0].level == 5) {
          this.formData.town = areaNode[0].label;
        }
      } else {
        this.formData.province = null;
        this.formData.city = null;
        this.formData.county = null;
        this.formData.town = null;
      }
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },

    // 地址懒加载
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },

    // 地址数据回显
    echoAddress() {
      if (this.formData.province) {
        let areaNamePath = this.formData.province + '/'
        if (this.formData.city) {
          areaNamePath = areaNamePath + this.formData.city + '/'
        }

        if (this.formData.county) {
          areaNamePath = areaNamePath + this.formData.county + '/'
        }

        if (this.formData.town) {
          areaNamePath = areaNamePath + this.formData.town
        }

        this.$http.post(api.basArea.getAreaOptionByAreaNamePathUrl, {areaNamePath: areaNamePath}).then(res => {
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          this.area = res.data.data.names
        })
      }
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http.post(api.basBuyShop.getDataUrl, {id: this.dataId}).then(res => {
          this.formData = res.data.data
          this.echoAddress()
        })
      }
    },

    saveData() {
      const rules = {
        shopType: [{prop: '类型', required: true, type: 'number', max: 99, }],
        shopCode: [{prop: '编码', required: true, type: 'string', maxlength: 20, }],
        shopName: [{prop: '名称', required: true, type: 'string', maxlength: 40, }],
        stat: [{prop: '状态', required: true, type: 'number', max: 99, }],
        shopDesc: [{prop: '店铺说明', required: false, type: 'string', maxlength: 40, }],
        shopManager: [{prop: '店长', required: false, type: 'string', maxlength: 20, }],
        shopPhone: [{prop: '联系方式', required: false, type: 'string', maxlength: 20, }],
      }
      this.$validate(this.formData, rules).then(() => {
        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()
          let url = (this.formData.id != null ? api.basBuyShop.updateDataUrl : api.basBuyShop.addDataUrl);
          this.$http.post(url, this.formData).then(res => {
            this.$message.success("保存成功！");
            this.goBackIndex()
            this.$mask.close()
          }).catch(() => {
            this.$message.error("保存失败！");
            this.$mask.close()
          })
        })
      })
    },

  },
};

</script>
<style lang="scss" scoped>
// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

</style>
